//* Importing Icons
import { BsFileEarmarkSpreadsheet, BsFillEyeFill } from "react-icons/bs";
import { MdDelete, MdModeEdit } from "react-icons/md";
import { RxSwitch } from "react-icons/rx";

export function Actions(props: {
  actionItem: { id: any };
  onDeleteClick?: () => void;
  onEditClick?: () => void;
  onManagerClick?: () => void;
  onAuxiliar1Click?: () => void;
  onPermissionClick?: () => void;
  hideManager?: boolean;
  hideEdit?: boolean;
  hideDelete?: boolean;
  showAuxiliar1?: boolean;
  showPermissions?: boolean;
}) {
  return (
    <div className="d-flex align-items-center justify-content-center">
      {props.showPermissions && (
        <span
          onClick={() => {
            if (props.onPermissionClick) props.onPermissionClick();
          }}
          className="icon p-1"
          style={{
            cursor: "pointer",
          }}
          title="Permissões"
        >
          <RxSwitch size={24} color="#007bff" />
        </span>
      )}
      {props.showAuxiliar1 == true && (
        <span
          onClick={() => {
            if (props.onAuxiliar1Click) props.onAuxiliar1Click();
          }}
          className="icon p-1"
          style={{
            cursor: "pointer",
          }}
          title="Baixar Arquivo .csv"
        >
          <BsFileEarmarkSpreadsheet size={24} color="#28a745" />
        </span>
      )}
      {!props.hideManager && (
        <span
          onClick={() => {
            if (props.onManagerClick) props.onManagerClick();
          }}
          className="icon p-1"
          style={{
            cursor: "pointer",
          }}
          title="Gerenciar"
        >
          <BsFillEyeFill size={24} color="#ffc107" />
        </span>
      )}
      {!props.hideEdit && (
        <span
          onClick={() => {
            if (props.onEditClick) props.onEditClick();
          }}
          className="icon p-1"
          style={{
            cursor: "pointer",
          }}
          title="Editar"
        >
          <MdModeEdit size={24} color="#6c757d" />
        </span>
      )}
      {!props.hideDelete && (
        <span
          onClick={() => {
            if (props.onDeleteClick) props.onDeleteClick();
          }}
          className="icon p-1"
          style={{
            cursor: "pointer",
          }}
          title="Deletar"
        >
          <MdDelete size={24} color="#dc3545" />
        </span>
      )}
    </div>
  );
}
